<div class="eventq-schedule-entry">
  @if (title(); as entryTitle) {
    <p class="eventq-schedule-entry__title">{{ entryTitle }}</p>
  }
  <div class="eventq-schedule-entry__days">
    <span class="eventq-schedule-entry__icon" aria-hidden="true">
      <img [src]="calendarIconSrc()" alt="" width="16" height="16" />
    </span>
    <span class="eventq-schedule-entry__text">{{ days() }}</span>
  </div>
  <div class="eventq-schedule-entry__time">
    <span class="eventq-schedule-entry__icon" aria-hidden="true">
      <img [src]="clockIconSrc()" alt="" width="16" height="16" />
    </span>
    <span class="eventq-schedule-entry__text">{{ time() }}</span>
  </div>
</div>
